import React from 'react';
import PropTypes from 'prop-types';

import { TooltipContainer, TooltipWrapper, TooltipContent } from './styles';

const Tooltip = ({ children, zIndex, bottom, isMobile, isBillsTooltip }) => {
  const components = React.Children.toArray(children);

  return (
    <TooltipWrapper>
      {components[0]}
      <TooltipContainer isMobile={isMobile} isBillsTooltip={isBillsTooltip} bottom={bottom} style={{ zIndex: zIndex }}>
        <TooltipContent>{components[1]}</TooltipContent>
      </TooltipContainer>
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  bottom: PropTypes.bool.isRequired,
  zIndex: PropTypes.number,
  isMobile: PropTypes.bool,
  isBillsTooltip: PropTypes.bool
};

export default Tooltip;
